import React from "react";
import { Dialog } from "@material-ui/core";

export function DialogContainer(props) {
  const { children, open, onClose, onKill, disableBackdropClick, fullWidth } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onExited={onKill}
      disableBackdropClick={disableBackdropClick == null ? false : disableBackdropClick}
      fullWidth={fullWidth}
      maxWidth={fullWidth ? props.maxWidth : "sm"}
    >
      {children}
    </Dialog>
  );
}
